import type { SearchEntityResult } from "fansunited-data-layer";

export type EntityLike = SearchEntityResult | undefined;

/** Logo/photo URL suitable for a `TeamLogo` `src` prop. */
export function getEntityLogo(entity: EntityLike): string | undefined {
    if (!entity) return undefined;
    if (entity.entityType === "team") return entity.assets?.logo ?? undefined;
    if (entity.entityType === "athlete") return entity.assets?.photo ?? entity.assets?.logo ?? undefined;
    if (entity.entityType === "competition") return entity.assets?.logo ?? undefined;
    return undefined;
}

export function getEntityCountryCode(entity: EntityLike): string | undefined {
    if (!entity) return undefined;
    if ((entity.entityType === "team" || entity.entityType === "athlete") && entity.country?.code) {
        return entity.country.code;
    }
    return undefined;
}

export function getEntityCountryFlag(entity: EntityLike): string | undefined {
    if (!entity) return undefined;
    if ((entity.entityType === "team" || entity.entityType === "athlete") && entity.country?.flag) {
        return entity.country.flag;
    }
    return undefined;
}

export function getEntityBrandColor(entity: EntityLike, tone: "primary" | "secondary"): string | undefined {
    if (!entity || entity.entityType !== "team") return undefined;
    return tone === "primary"
        ? entity.metadata?.branding?.primaryColor
        : entity.metadata?.branding?.secondaryColor;
}

export function getEntityShortName(entity: EntityLike): string | undefined {
    if (!entity) return undefined;
    if ("shortName" in entity && entity.shortName) return entity.shortName;
    return undefined;
}
